import { z } from 'zod';

export const apiKeyStatusSchema = z.enum(['active', 'revoked']);

export const createApiKeyInputSchema = z.object({
  name: z.string().min(1, 'Name is required').max(100, 'Name too long'),
  description: z.string().max(500).optional(),
});

export const apiKeyPrefixSchema = z.string().regex(/^auctaim_live_/, 'Invalid API key format');
